import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Roles } from '../../../models/roles';
import { AppService } from '../../../services/app.service';
import { AuthService } from '../../../services/auth.service';
import { SupportTicketsService } from '../../../services/support-tickets.service';

@Component({
  selector: 'app-create-support-ticket',
  templateUrl: './create-support-ticket.component.html',
  styleUrl: './create-support-ticket.component.scss',
})
export class CreateSupportTicketComponent implements OnInit {
  showSupportModal = false;
  creatingTicket = false;

  ticketCategoryOptions = [
    { value: 'cashout_issue', name: 'Tengo problemas con un cashout' },
    { value: 'cashin_issue', name: 'Tengo problemas con un cashin' },
    { value: 'transfer_issue', name: 'Tengo problemas con una transferencia' },
    { value: 'payment_issue', name: 'Tengo problemas con un pago' },
    { value: 'account_issue', name: 'Tengo problemas con mi cuenta' },
    { value: 'verification_issue', name: 'Tengo problemas con una verificación' },
    { value: 'card_issue', name: 'Tengo problemas con una tarjeta virtual' },
    { value: 'rate_issue', name: 'Tengo dudas sobre tasas o conversiones' },
    { value: 'technical_issue', name: 'Tengo un problema técnico en la plataforma' },
    { value: 'other', name: 'Necesito ayuda con otro tema' },
  ];

  supportTicketForm = this.formBuilder.group({
    subject: ['', Validators.required],
    description: ['', Validators.required],
    category: [null, Validators.required],
  });

  constructor(
    public authService: AuthService,
    public appService: AppService,
    private formBuilder: FormBuilder,
    private supportTicketsService: SupportTicketsService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.showSupportModal = true;
  }

  canCreateSupportTicket(): boolean {
    return this.authService.role !== Roles.Admin;
  }

  closeModal() {
    this.showSupportModal = false;
    this.appService.triggerCreateSupportTicket(false);
  }

  checkSupportDisabled(): boolean {
    return this.creatingTicket || this.supportTicketForm.invalid;
  }

  createSupportTicket() {
    if (this.checkSupportDisabled()) return;

    const category = this.supportTicketForm.controls.category.value as {
      value?: string;
    } | null;

    const body = {
      subject: String(this.supportTicketForm.controls.subject.value || '').trim(),
      description: String(this.supportTicketForm.controls.description.value || '').trim(),
      category: category?.value || undefined,
    };

    if (!body.subject || !body.description || !body.category) {
      this.supportTicketForm.controls.subject.markAsTouched();
      this.supportTicketForm.controls.description.markAsTouched();
      this.supportTicketForm.controls.category.markAsTouched();
      return;
    }

    this.creatingTicket = true;

    this.supportTicketsService.createSupportTicket(body).then(
      () => {
        this.creatingTicket = false;
        this.closeModal();
        this.messageService.add({
          severity: 'success',
          summary: 'Listo',
          detail: 'Hemos creado tu ticket de soporte.',
        });
      },
      () => {
        this.creatingTicket = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Ocurrió un error al crear el ticket de soporte.',
        });
      },
    );
  }
}
